/* eslint-disable max-len */
// prettier-ignore
module.exports = {
  // ================ CONTACTS ================
  contacts: {
    text1: "Контакты",
    text2: "Общество с ограниченной ответственностью",
    firmName: "«Геоконтроль-НН»",
    firmAddress: "Адрес: 603014, Россия, г.Нижний Новгород, Сормовское шоссе, д.24/6, пом.3",
    firmINN: "ИНН 5250059408",
    firmKPP: "КПП 525001001",
    firmOGRN: "ОГРН 1145250000125",
    firmPhone: "Телефон +7 (831) 410-24-11",
    markerlabel: "Геоконтроль-НН<br>Сормовское шоссе, д.24/6",
    ourworkers: [
      {
        position: "Директор",
        name: "Павел Сергеевич",
        phone: "+79040498124"
      },
      {
        position: "Главный инженер",
        name: "Максим Валерьевич",
        phone: "+79108876927"
      },
      {
        position: "Начальник ЛНК",
        name: "Василий Викторович",
        phone: "+79006254541"
      }
    ]
  }
};
/* eslint-enable max-len */
